import api, { UPLOAD } from "./api";

export const UploadFile = async (file) => {
  return await api.post(`${UPLOAD}/`, file);
};

export const deleteFile = async (url) => {
  return await api.delete(`${UPLOAD}?path=${url}`);
};
